function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import history from 'helpers/history';
import SessionStorage from 'libs/SessionStorage';
import { AppContext } from 'context';
import urlRouteShape from 'shapes/urlRouteShape';
import Information from 'modules/Information';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import InformationForm from './InformationForm';
import MissingLegalConsents from './MissingLegalConsents';
var _React_PureComponent;
class SetInformation extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        const { information, isEdit, isNoMandatoryConsent, isNoMandatoryInformation } = this.props;
        if (!isNoMandatoryConsent && !isNoMandatoryInformation && !isEdit && information) {
            this.navigate();
        }
    }
    componentDidUpdate(prevProps) {
        const { information, isEdit, isNoMandatoryConsent, isNoMandatoryInformation, isInProgress } = this.props;
        if (!isNoMandatoryConsent && !isNoMandatoryInformation && (prevProps.isInProgress !== isInProgress && !isInProgress || !isEdit && prevProps.information !== information && information)) {
            this.navigate();
        }
    }
    navigate() {
        if (this.blsReturnUrl) {
            this.context.externalRedirect(this.blsReturnUrl);
            return;
        }
        const { name, params } = this.props.mainUrlRoute;
        const url = this.context.getUrl(name, params);
        history.replace(url);
    }
    render() {
        const { information, isEdit, isNoMandatoryConsent, isNoMandatoryInformation } = this.props;
        if (isNoMandatoryConsent) {
            return /*#__PURE__*/ _jsx(MissingLegalConsents, _object_spread({}, this.props));
        }
        if (isEdit && information || isNoMandatoryInformation) {
            return /*#__PURE__*/ _jsx(InformationForm, _object_spread({}, this.props));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.blsReturnUrl = SessionStorage.getItem('blsReturnUrl');
    }
}
_define_property(SetInformation, "contextType", AppContext);
_define_property(SetInformation, "propTypes", {
    // Explicit props
    scopeName: shapes.scopeName,
    isEdit: PropTypes.bool,
    // Implicit props
    information: PropTypes.object,
    mainUrlRoute: urlRouteShape,
    isNoMandatoryConsent: PropTypes.bool,
    isNoMandatoryInformation: PropTypes.bool,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool
});
_define_property(SetInformation, "defaultProps", {
    isEdit: false
});
const mapStateToProps = (state)=>({
        mainUrlRoute: selectors.mainUrlRoute(state),
        information: Information.selectors.information(state),
        isNoMandatoryConsent: Information.selectors.isNoMandatoryConsent(state),
        isNoMandatoryInformation: Information.selectors.isNoMandatoryInformation(state),
        isInProgress: Information.selectors.isSendInformationInProgress(state),
        hasErrors: Information.selectors.hasSendInformationErrors(state)
    });
const ConnectedSetInformation = connect(mapStateToProps)(SetInformation);
export default ConnectedSetInformation;
